var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu04Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.1804C22 16.2507 17.5228 20.3609 12 20.3609C10.7314 20.3609 9.51807 20.144 8.40143 19.7485L3.617 20.9686C2.88462 21.1554 2.22123 20.4787 2.40432 19.7316L3.36471 15.8131C2.49724 14.4532 2 12.8701 2 11.1804C2 6.11022 6.47715 2 12 2C17.5228 2 22 6.11022 22 11.1804Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu04Filled);
export default __webpack_public_path__ + "static/media/icon_menu04_filled.5a37d356aab518c6d339b0b07f3ebadf.svg";
export { ForwardRef as ReactComponent };